import {useAppSelector} from "@Hooks/selector/useAppSelector";
import useUpdateTicketFromVoucher from "@CheckOrder/hooks/useUpdateTicketFromVoucher";

export default function useRemoveVoucher() {
    const {ticketCode} = useAppSelector((state) => state?.checkOrder.ticket)
    const params = {ticket_code: ticketCode};
    const updateTicket = useUpdateTicketFromVoucher('/ajax/remove-voucher', params)

    return () => updateTicket()
}